import { render } from "./SponsorEdit.vue?vue&type=template&id=424affae"
import script from "./SponsorEdit.vue?vue&type=script&lang=js"
export * from "./SponsorEdit.vue?vue&type=script&lang=js"
script.render = render

export default script